import { z } from "zod";

export const projectListSearchSchema = z.object({
  view: z.enum(["trash", "templates"]).optional(),
  from: z.enum(["organisation", "library", "tenders", "deals", "chrono-devis"]).optional(),
});

export type ProjectListView = "active" | "trash" | "templates";
